<template>
  <div>
    <Multiselect
      v-model="value"
      :options="options"
      class="playerCat"
      placeholder="SELECT PLAYER"
      
    ></Multiselect>
  </div>
</template>

<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped>

div {
  width: 200px;
}
.playerCat {
  font-family: Play;
  font-weight:bold;
  // line-height:20px;
  
 color:$grey;
  margin: 50px 0px 0px 0px;
  --ms-font-size: 14px;
  --ms-radius: 30px;
  --ms-border-color: $white;
  --ms-bg: linear-gradient(#e3fc00, #a8ba04);
  --ms-dropdown-bg: #a8ba04;
  --ms-dropdown-border-color: none;
  --ms-placeholder-color: #373946;;
  --ms-line-height: 2;
  --ms-option-color-selected: green;
  @include respond(phone-only){
    --ms-option-font-size: 12px;
  }
}
</style>

<script>
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [
        {value:0,label:"Cristiano Ronaldo"},
        {value:1,label:"Lionel Messi"},
        {value:2,label:"Neymar JR"},
        {value:3,label:"Kylian Mbappe"},
        {value:4,label:"Mohamed Salah"},
        {value:5,label:"Robert Lewandowski"},
        {value:6,label:"Andres Iniesta"},
        {value:7,label:"Paul Pogba"},
        {value:8,label:"Gareth Bale"},
        {value:9,label:"Eden Hazard"},
        {value:10,label:"Carli Lloyd"},
        {value:11,label:"Sam Kerr"},
        {value:12,label:"Alex Morgan"},
        {value:13,label:"Megan Rapinoe"},
        {value:14,label:"Julie Ertz"},
        {value:15,label:"Ada Hegerberg"},
        {value:16,label:"Marta"},
        {value:17,label:"Amandine Henry"},
        {value:18,label:"Wendie Renard"},
        {value:19,label:"Christine Sinclair"}
      ],
    };
  },
  watch: {
    value: function () {
      if (this.value === null) {
        this.value = 0;
      }
    
      this.$store.commit("setPlayer", { index: this.value});
      this.$store.commit("setPlayerData");
    },
  },
  mounted() {
    this.selectedPlayer = this.$store.getters.getSelectedPlayer;
  },
};
</script>